module.exports = __webpack_public_path__ + "static/media/university.12f3e1d7.svg";